import { gql, QueryHookOptions, QueryResult } from '@apollo/client';

import { useAPIQuery } from 'Api/handler';

import { Request, User, Company } from 'Types';
import { GET_CLIENTS_FRAGMENT, GET_SHIPPERS_FRAGMENT } from '../Fragments';

export type GetRequestsResponse = {
  requests: Request[];
  shippers: User[];
  clients: Company[];
};

export type GetRequestsVariables = {
  originCountry?: string;
  destinationCountry?: string;
  departureDept?: string;
  arrivalDept?: string;
  status?: number[];
  dangerous?: boolean;
  shipper?: number;
  client?: number;
  reference?: string;
  createdAtMin?: Date;
  createdAtMax?: Date;
};

export const useGetRequests = (
  options?: QueryHookOptions<GetRequestsResponse, GetRequestsVariables>,
): QueryResult<GetRequestsResponse, GetRequestsVariables> => {
  return useAPIQuery(GET_REQUESTS, options);
};

export const GET_REQUESTS = gql`
  query GetRequests(
    $originCountry: String
    $destinationCountry: String
    $departureDept: String
    $arrivalDept: String
    $status: [Float]
    $shipper: Float
    $dangerous: Boolean
    $client: Float
    $reference: String
    $createdAtMin: Date
    $createdAtMax: Date
  ) {
    requests(
      originCountry: $originCountry
      destinationCountry: $destinationCountry
      departureDept: $departureDept
      arrivalDept: $arrivalDept
      status: $status
      shipper: $shipper
      dangerous:$dangerous
      client: $client
      reference: $reference
      createdAtMin: $createdAtMin
      createdAtMax: $createdAtMax
    ) {
      id
      reference
      createdAt
      date
      originCountry
      originCity
      originZipcode
      destinationCountry
      destinationCity
      destinationZipcode
      floorMeters
      handlingUnitNb
      dangerous
      lastValidQuotation {
        id
        totalAmount
      }
      company {
        name
        type
      }
      account {
        id
        codeTiers
        agency {
          name
          id
          cgv
          code
          teliway {
            code
            name
          }
        }
      }
      user {
        id
        fullName
        role
        isActive
      }
      status {
        id
        value
        label
      }
      elapsedTime
      totalQuotations
    }
    ...Shippers
    ...Clients
  }
  ${GET_CLIENTS_FRAGMENT}
  ${GET_SHIPPERS_FRAGMENT}
`;
